///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'button[windeActionIcon]',
    standalone: false
})
export class ActionIconButtonDirective {
    @HostBinding('class') buttonClass = 'winde-button winde-action-icon';
    @HostBinding('type') buttonType = 'button';
}
